
    {
  (function($){
    $.fn.extend({
        mAccord: function(options) {
            var defaults = {
            };
            var options = $.extend(defaults, options);

            return this.each(function() {
              var o = options,
                  // container = $(this).find(".accordion-container"),
                  trigger = $(this).find(".accordion h3"),
                 // acc-content =$(this).find(".accordion-content")
                  content = $(this).find(".accordion-content"),
                 
                  obj = $(trigger).prev();
                  $(".accordion-container .accordion:nth-child(1) h3").addClass("faq_active");
                  $(".accordion-container .accordion:nth-child(1) h3").next().slideDown(500);
               $(".accordion-container .accordion .accordion-content").addClass("faq_active");
              trigger.click(function (e) {
                e.stopPropagation();
                var target = $(this).next();

                $(this).addClass('faq_active'),
                trigger.not(this).removeClass('faq_active'),
                  content.not(this).removeClass('faq_active'),
                target.stop().delay().slideDown(500);

                if (target.is(':visible')) { 
                  $(this).removeClass('faq_active'),
                  target.stop().slideUp();
                } else if (content.not(target).is(':visible')){
                  $(content.not(target)).stop().slideUp(500);
                }
              });
              
					});
        }
    });
})(jQuery);

(function($) { 
  $('.accordion-container').mAccord();
})(jQuery);
}






    {
  (function($){
    $.fn.extend({
        mAccord: function(options) {
            var defaults = {
            };
            var options = $.extend(defaults, options);

            return this.each(function() {
              var o = options,
                  trigger = $(this).find("h2.footer-block__heading.inline-richtext"),
                 // acc-content =$(this).find(".accordion-content")
                  content = $(this).find("ul.footer-block__details-content.list-unstyled"),
                 
                  obj = $(trigger).prev();
                  $(".accordion-container .accordion:nth-child(1) h3").addClass("faq_active");
                  $(".accordion-container .accordion:nth-child(1) h3").next().slideDown(500);
               $(".accordion-container .accordion .accordion-content").addClass("faq_active");
              trigger.click(function (e) {
                e.stopPropagation();
                var target = $(this).next();

                $(this).addClass('faq_active'),
                trigger.not(this).removeClass('faq_active'),
                  content.not(this).removeClass('faq_active'),
                target.stop().delay().slideDown(500);

                if (target.is(':visible')) { 
                  $(this).removeClass('faq_active'),
                  target.stop().slideUp();
                } else if (content.not(target).is(':visible')){
                  $(content.not(target)).stop().slideUp(500);
                }
              });
              
					});
        }
    });
})(jQuery);

(function($) { 
  $('.accordion-container').mAccord();
})(jQuery);
}




